<zwi-main-wrapper>
  <zwi-ministry-sermons [username]="username"></zwi-ministry-sermons>
</zwi-main-wrapper>